import { LoggingOptions, TokenEndpointOptions, TokenEndpointResponse } from './global';
import { getJSON } from './http';
import { createQueryParams, getLoggingFormat } from './utils';

export async function oauthToken(
  {
    baseUrl,
    timeout,
    audience,
    scope,
    ...options
  }: TokenEndpointOptions,
  worker?: Worker,
  loggingOptions?: LoggingOptions
) {
  const reqbody = createQueryParams(options);
  const loggingData = getLoggingFormat(loggingOptions);

  return await getJSON<TokenEndpointResponse>(
    baseUrl+'/token',
    timeout,
    audience || 'default',
    scope,
    {
      method: 'POST',
      body: reqbody,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json, text/plain, */*',
        'x-request-id': loggingData
      }
    },
    worker
  );
}
